<template lang='pug'>
ul.task
  li.task__item(
    v-for="text in block.text"
    :key="text"
    )
    div.task__container
      span.task__text(v-html="text")
</template>

<script>
export default {
  name: 'TaskComponent',
  props: {
    block: {
      type: Object,
      default: () => {},
    }
  },
}
</script>

<style lang='scss' scoped>
.task {
  &__item {
    margin-bottom: 35px;
  }

  &__container {
    display: flex;
    align-items: flex-start;
    background: url('~/assets/images/services/marker.svg') no-repeat;
    background-position: top left;
    min-height: 54px;
  }

  &__text {
    padding-top: 1rem;
    padding-left: 5.2rem;
  }
}
</style>
